
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cycle-scope",
      function () {
        return require("private-next-pages/cycle-scope.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cycle-scope"])
      });
    }
  